import { Environment } from '../config/environment';
import { AdultType, AssetType, ExtraDataType } from './models/Shared.types';
import { Backend } from './Backend';
import { ISearchResponseV3 } from './models/AndromeTV.types';

export class SearchApi {
  static search(
    backend: Backend,
    searchTerm: string,
    types: AssetType[],
    adult: AdultType,
    catalogId: string,
    completions: boolean,
    page = 0,
    extraData: ExtraDataType = ExtraDataType.NONE
  ): Promise<ISearchResponseV3> {
    const query: any = {};
    query.platform = Environment.system;
    query.term = searchTerm;
    query.catalogId = catalogId;
    query.completions = completions;
    query.page = page;
    query.extraData = extraData;
    query.adult = adult;

    query.type = types;

    const url = backend.makeUrl('search/v3/search', query);

    return backend.getJson(url, backend.bearer) as Promise<ISearchResponseV3>;
  }
}
